import {
  CREATE_SUCCESS,
  CREATE_FAIL,
  UPLOAD_FILE_SUCCESS,
  UPLOAD_FILE_FAIL,
  SEARCH,
  UPDATE_SUCCESS,
  UPDATE_FAIL,
  ACCOUNT_STOP,
  EXCEL_DOWNLOAD
} from "../actions/staff";
const initialState = { row: { id: 0 } };

const staff = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case CREATE_SUCCESS:
      return {
        ...state,
        regist_staff: payload.staff,
        message: payload.message
      };
    case CREATE_FAIL:
      return {
        ...state,
        message: payload
      };
    case UPLOAD_FILE_SUCCESS:
      return {
        ...state,
        message: payload
      };
    case UPLOAD_FILE_FAIL:
      return {
        ...state,
        message: payload
      };
    case SEARCH:
      return {
        ...state,
        params: payload.params,
        row: payload.staffs
      };
    case UPDATE_SUCCESS:
      return {
        ...state
      };
    case UPDATE_FAIL:
      return {
        ...state,
        message: payload.message
      };
    case ACCOUNT_STOP:
      return {
        ...state,
        params: payload.params
      };
    case EXCEL_DOWNLOAD:
      return {
        ...state,
        url: payload.url
      };
    default:
      return {
        ...state
      };
  }
};

export default staff;
